<footer class="footer">
  <div class="container footer-content">
    <div class="footer-brand">
      <div class="brand">
        <span class="logo-accent">Nakel</span>Services
      </div>
      <p class="brand-desc">South Africa's on-demand marketplace for professional home services. Connecting quality with convenience across Johannesburg, Pretoria &amp; Sandton.</p>
      <div class="footer-social">
        <a href="#" aria-label="Facebook" class="social-link">f</a>
        <a href="#" aria-label="LinkedIn" class="social-link">in</a>
        <a href="#" aria-label="Twitter" class="social-link">𝕏</a>
        <a href="#" aria-label="WhatsApp" class="social-link">💬</a>
      </div>
    </div>

    <div class="footer-links">
      <div class="link-group">
        <h4>Platform</h4>
        <a routerLink="/services">Services</a>
        <a routerLink="/home" fragment="how-it-works">How It Works</a>
        <a routerLink="/home" fragment="pricing-section">Pricing</a>
        <a routerLink="/coverage">Coverage Areas</a>
        <a routerLink="/faq">FAQ</a>
        <a routerLink="/auth/provider-register">Provider Portal</a>
      </div>

      <div class="link-group">
        <h4>Legal</h4>
        <a routerLink="/terms">Terms &amp; Conditions</a>
        <a routerLink="/privacy-policy">Privacy Policy (POPIA)</a>
        <a routerLink="/faq">Satisfaction Guarantee</a>
        <a routerLink="/terms">Provider Agreement</a>
        <a routerLink="/privacy-policy">POPIA Compliance</a>
      </div>

      <div class="link-group">
        <h4>Support</h4>
        <a routerLink="/faq">Help Center</a>
        <a href="tel:+27722954699" class="support-contact">
          <mat-icon>phone</mat-icon>
          +27 72 295 4699
        </a>
        <a href="mailto:info@nakelservices.co.za" class="support-contact">
          <mat-icon>email</mat-icon>
          info&#64;nakelservices.co.za
        </a>
        <a href="https://wa.me/27722954699" target="_blank" rel="noopener noreferrer" class="support-contact">
          <mat-icon>chat</mat-icon>
          WhatsApp Support
        </a>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="container bottom-inner">
      <div class="bottom-left">
        <p>&copy; {{ currentYear }} Nakel Services Proprietary Limited · Registration No: 2025/369254/07 · CIPC Compliant</p>
      </div>
      <div class="bottom-badges">
        <span class="footer-badge">
          <mat-icon>lock</mat-icon>
          Paystack Secured
        </span>
        <span class="footer-badge">
          <mat-icon>verified_user</mat-icon>
          POPIA Compliant
        </span>
        <span class="footer-badge">
          <mat-icon>flag</mat-icon>
          SA Registered
        </span>
      </div>
    </div>
  </div>
</footer>
